import React, { useState } from 'react';
import { useTrackCustomEvent } from '../../../utils/useTrackCustomEvent';
import ChatBubbleButton from '../ChatBubbleButton';
import ContactFormView from '../../ContactFormView';
import styles from './index.module.scss';

export default function FloatingChatBubble() {
  let trackCustomEvent = useTrackCustomEvent();
  const [isContactFormVisible, setIsContactFormVisible] = useState(false);

  return (
    <div className={styles.floatingChatBubble}>
      <ChatBubbleButton
        ariaLabel="Contact us"
        onClick={() => {
          trackCustomEvent({
            category: `Everywhere - Chat Bubble icon`,
            action: `Chat bubble icon clicked`,
            label: window.location.pathname,
          });
          setIsContactFormVisible(true);
        }}
      />
      <ContactFormView isVisible={isContactFormVisible} closeFn={() => setIsContactFormVisible(false)} standalone />
    </div>
  );
}
